import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { NavBar } from 'components/NavBar/NavBar'
import { NoData } from 'components/NoData'
import { Pagination } from 'components/Pagination/Pagination'
import { clearPermits, getPermits } from 'features/operations/permitsSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { StatusBadge } from 'pages/Operations/Operations.styled'
import { RootState } from 'store'
import { Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'
import { IGetAllPermitsSingleResponse } from 'types/api/operationsPermitsApi.interface'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { apiLevelToZoneValue, permitStatuses, zoneScopeLevels } from './permitsData'

const formatZoneScope = (zoneScope: IGetAllPermitsSingleResponse['zoneScope']) => {
    if (!zoneScope?.level) return '-'
    const levelLabel = zoneScopeLevels.find((l) => l.value === apiLevelToZoneValue[zoneScope.level])?.label
    const count = zoneScope.ids?.length ?? 0
    return count ? `${levelLabel} (${count})` : levelLabel || zoneScope.level
}

const columns: IHonestTableColumn<IGetAllPermitsSingleResponse>[] = [
    {
        id: 'type',
        header: 'Type',
        sortable: true,
        sticky: true,
        minWidth: '12rem',
        cell: (item) => (
            <Cell>
                <BodyText weight='600'>{item.permitType?.name}</BodyText>
            </Cell>
        ),
    },
    {
        id: 'status',
        header: 'Status',
        sortable: true,
        minWidth: '10rem',
        cell: (item) => {
            const status = permitStatuses.find((s) => s.value === item.status)
            return (
                <StatusBadge hexColor={status?.color}>{status?.label}</StatusBadge>
            )
        },
    },
    {
        id: 'validFrom',
        header: 'Issued',
        sortable: true,
        minWidth: '12rem',
        cell: (item) => <BodyText>{item.issuedAt ? formatDateForDisplay(item.issuedAt) : '-'}</BodyText>,
    },
    {
        id: 'validTo',
        header: 'Valid to',
        sortable: true,
        minWidth: '12rem',
        cell: (item) => (
            <BodyText>{item.expiresAt ? formatDateForDisplay(item.expiresAt) : '-'}</BodyText>
        ),
    },
    {
        id: 'scope',
        header: 'Scope',
        sortable: true,
        minWidth: '12rem',
        cell: (item) => <BodyText>{formatZoneScope(item.zoneScope)}</BodyText>,
    },
    {
        id: 'spacer',
        header: '',
        fill: true,
        cell: () => null,
    },
]



export const Permits = () => {
    const navigate = useNavigate()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { data, totalPages } = useSelector((state: RootState) => state.permits.permits)

    useQueryPagination({ fetchFunctions: [getPermits], cleanUpFunctions: [clearPermits], params })

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between width='100%' mb='16'>
                    <H1WithBack arrow title='Permits' />
                    <Flex gap='1rem'>
                        <Button orange onClick={() => navigate('types')}>
                            Types
                        </Button>
                        <Button orange onClick={() => navigate('add')}>
                            Add permit
                        </Button>
                    </Flex>
                </Flex>
                {data?.length ? (
                    <HonestTable columns={columns} data={data} keyField='id' />
                ) : (
                    <NoData text='No permits to display' />
                )}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
